/**
 * @description 设置对history变化的监听事件
 * @param param0
 */
export default function addHistoryListener({ replaceListener, pushListener, popListener }) {
  // 监听路由变化（进栈、出栈）----------- start
  // TODO 主要就是想解决微信浏览器中，页面返回，页面不更新的重大bug。尚未解决！但prd却没有出现这bug
  /* eslint-disable */
  const bindEventListener = function (type) {
    const historyEvent = window.history[type];
    return function () {
      const newEvent = historyEvent.apply(this, arguments);
      const e = new Event(type);
      (e as any).arguments = arguments;
      window.dispatchEvent(e);
      return newEvent;
    };
  };
  window.history.pushState = bindEventListener('pushState');
  window.history.replaceState = bindEventListener('replaceState');

  const handleReplaceState = (e) => {
    console.log('THEY DID IT AGAIN! replaceState -------', e);
    replaceListener && replaceListener(e);
  };

  const handlePushState = (e) => {
    console.log('THEY DID IT AGAIN! pushState -------', e);
    pushListener && pushListener(e);
  };

  const handlePopstate = (e) => {
    console.log('THEY DID IT AGAIN! popstate -------', e);
    popListener && popListener(e);
  };

  window.addEventListener('replaceState', handleReplaceState);
  window.addEventListener('pushState', handlePushState);
  window.addEventListener('popstate', handlePopstate);

  /* eslint-disable */
  // 监听路由变化（进栈、出栈）----------- end

  const unRegisterListener = () => {
    window.removeEventListener('replaceState', handleReplaceState);
    window.removeEventListener('pushState', handlePushState);
    window.removeEventListener('popstate', handlePopstate);
  };

  return unRegisterListener;
}
